import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    // clientId: "7185a779-a29f-423d-8b66-40cb92dfb5f3",

    clientId: window?.runtimeConfig?.clientId,

    //clientId: "8a2c1a76-c99f-4235-b95b-43da1016e96d",
    // authority: "https://login.microsoftonline.com/de77ee43-8ceb-489c-9e8a-024f2c4e1a62",

    authority: window?.runtimeConfig?.authority,

    redirectUri: window?.runtimeConfig?.REACT_APP_REDIRECT_URI,
    // redirectUri: window?.runtimeConfig?.redirectUri,
    /*   redirectUri: "http://localhost:3000/"*/
    // redirectUri: "https://ini.whizible.com/loadingPage"
    //redirectUri: "https://ini-sales.whizible.com/loadingPage"
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ["User.Read"],
  //scopes: ["api://7185a779-a29f-423d-8b66-40cb92dfb5f3/react_UserAccess"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me", //e.g. https://graph.microsoft.com/v1.0/me
};
